/* global __API_ROOT_URL__ */
import angular from 'angular';
import constants from 'app/constants';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';

let _$http;
let _utilityService;

export class assetDataService {
  constructor(
    $http,
    Upload,
    utilityService, // eslint-disable-line no-shadow
  ) {
    _$http = $http;
    _utilityService = utilityService;

    console.log('app.services.controlDataService created');
  }

  // ///////////// Asset Administration ///////////////////

  initAssetAdmin(includeInstances) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerAssetAdministration/init`,
      method: 'GET',
      params: {
        includeInstances,
      },
    });
  }

  getRisk(riskId) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerRisk/${riskId}`,
      method: 'GET',
      params: { includeControls: true },
    });
  }

  // ///////////// Asset Types ///////////////////

  getAssetTypes() {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerAssetType`,
      method: 'GET',
      params: { includeControls: true, includeRisks: true },
    });
  }

  getAssetType(customerAssetTypeId) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerAssetType/${customerAssetTypeId}`,
      method: 'GET',
      params: { includeControls: true, includeRisks: true },
    });
  }

  getAssetTypeWithInstances(customerAssetTypeId) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerAssetAdministration/customerInitAssetType/${customerAssetTypeId}`,
      method: 'GET',
      params: { includeControls: true, includeRisks: true },
    });
  }

  getAssetTypeDefaults() {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerAssetType/default`,
      method: 'GET',
    });
  }

  isCustomerAssetTypeInSync(customerAssetTypeId) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerAssetType/${customerAssetTypeId}/syncWithMaster`,
      method: 'GET',
      params: {
        id: customerAssetTypeId,
        name,
      },
    });
  }

  checkCustomerAssetTypeExists(customerAssetTypeId, name) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerAssetType/exists`,
      method: 'GET',
      params: {
        id: customerAssetTypeId,
        name,
      },
    });
  }

  saveAssetType(assetType) {
    let _url = `${__API_ROOT_URL__}/ent/customerAssetType`;
    let _method = 'POST';

    if (assetType.customerAssetTypeId > 0) {
      _url = `${__API_ROOT_URL__}/ent/customerAssetType/${assetType.customerAssetTypeId}`;
      _method = 'PUT';
    }

    return _$http({
      url: _url,
      method: _method,
      data: _utilityService.serializeData(assetType),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  copyAssetType(assetTypeId, name) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerAssetType/copy`,
      method: 'PUT',
      params: {
        id: assetTypeId,
        name,
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteAssetType(assetTypeId) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerAssetType/${assetTypeId}`,
      method: 'DELETE',
    });
  }

  saveAssetRiskTypes(customerAssetTypeId, customerRiskTypes) {
    const _url = `${__API_ROOT_URL__}/ent/customerAssetType/${customerAssetTypeId}/addRisks`;
    // const _url = `${__API_ROOT_URL__}/ent/customerAssetTypeCustomerRiskType/bulkSave/${customerAssetTypeId}`;
    const _method = 'PUT';

    return _$http({
      url: _url,
      method: _method,
      data: JSON.stringify(customerRiskTypes),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  // ///////////// Assets ///////////////////

  getAsset(customerAssetId) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerAsset/${customerAssetId}`,
      method: 'GET',
      params: { includeControls: true, includeRisks: true },
    });
  }

  getAssets() {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerAsset`,
      method: 'GET',
      params: { includeControls: true, includeRisks: true },
    });
  }

  checkCustomerAssetExists(customerAssetId, name) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerAsset/exists`,
      method: 'GET',
      params: {
        id: customerAssetId,
        name,
      },
    });
  }

  saveAsset(asset) {
    let _url = `${__API_ROOT_URL__}/ent/customerAsset`;
    let _method = 'POST';

    if (asset.customerAssetId > 0) {
      _url = `${__API_ROOT_URL__}/ent/customerAsset/${asset.customerAssetId}`;
      _method = 'PUT';
    }

    return _$http({
      url: _url,
      method: _method,
      data: JSON.stringify(asset),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  syncAssetTypeWithMaster(customerAssetTypeId) {
    let _url = `${__API_ROOT_URL__}/ent/customerAssetType`;
    let _method = 'POST';

    if (customerAssetTypeId > 0) {
      _url = `${__API_ROOT_URL__}/ent/customerAssetType/${customerAssetTypeId}/syncWithMaster`;
      _method = 'PUT';
    }

    return _$http({
      url: _url,
      method: _method,
      // data: JSON.stringify(asset),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  getNetComplyAssetTypeCount(customerAssetTypeId) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerAssets/${customerAssetTypeId}/getNetcomplyCounts`,
      method: 'GET',
      params: {
        id: customerAssetTypeId,
      },
    });
  }

  getDattoAssetTypeCount(customerAssetTypeId) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerAssets/${customerAssetTypeId}/getDattoCounts`,
      method: 'GET',
      params: {
        id: customerAssetTypeId,
      },
    });
  }

  synchronizeAssetTypesFromNetComply(customerAssetTypeId) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerAssets/${customerAssetTypeId}/importNetcomply`,
      method: 'POST',
      params: {
        echo: true,
      },
    });
  }

  synchronizeAssetTypesFromDatto(customerAssetTypeId) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerAssets/${customerAssetTypeId}/importDatto`,
      method: 'POST',
      params: {
        echo: true,
      },
    });
  }

  deleteAsset(assetId) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerAsset/${assetId}`,
      method: 'DELETE',
    });
  }

  syncAsset(assetSyncDTO) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerAsset/syncToCustomerAssetType`,
      method: 'PUT',
      data: JSON.stringify(assetSyncDTO),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  bulkDeleteAssets(idList) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerAsset/bulkDelete`,
      method: 'PUT',
      data: JSON.stringify(idList),
      params: { echo: true },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  bulkChangeAssetTypes(newAssetTypeId, customerAssetIdList) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerAsset/bulkChangeAssetType`,
      method: 'PUT',
      data: JSON.stringify(customerAssetIdList),
      params: {
        newAssetTypeId,
        echo: true,
      },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  copyAsset(assetId, name, assetPrefix) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerAsset/copy`,
      method: 'PUT',
      params: {
        id: assetId,
        name,
        assetPrefix,
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  // ///////////// Asset Risks ///////////////////

  saveAssetRisks(customerAssetId, customerRiskIds) {
    const _url = `${__API_ROOT_URL__}/ent/customerAssetCustomerRisk/bulkSave/${customerAssetId}`;
    const _method = 'POST';

    return _$http({
      url: _url,
      method: _method,
      data: JSON.stringify(customerRiskIds),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  unassignCustomerAssetRiskType(customerAssetTypeId, customerRiskType) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerAssetType/${customerAssetTypeId}/deleteRisk`,
      method: 'PUT',
      data: JSON.stringify(customerRiskType),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  // ///////////// Asset Prefixes ///////////////////

  checkTypePresetsForDuplicates(customerAssetId, prefix) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerAssetPrefix/checkExists`,
      method: 'GET',
      params: {
        id: customerAssetId,
        prefix,
      },
    });
  }

  createTypePresets(customerAssetId, prefix) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerAssetPrefix/${customerAssetId}/`,
      method: 'PUT',
      params: {
        prefix,
        echo: true,
      },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  // ///////////// Asset Controls ///////////////////

  saveControlSettings(settings) {
    const _url = `${__API_ROOT_URL__}/ent/controlAdministrationSettings`;
    const _method = 'POST';

    // if (control.customerControlId > 0) {
    //   _url = `${__API_ROOT_URL__}/ent/customerControl/${control.customerControlId}`;
    //   _method = 'PUT';
    // }

    return _$http({
      url: _url,
      method: _method,
      data: JSON.stringify(settings),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  getControlWeights() {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/customerControlTypeWeight`,
      method: 'GET',
    });
  }
}

assetDataService.$inject = ['$http', 'Upload', 'utilityService'];
export default angular
  .module('app.services.assetDataService', [ngFileUpload, constants])
  .service('assetDataService', assetDataService).name;
